var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildkiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -42.5 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#30F2A2",
    points: "0 0 85.3333333 41.8133333 85.3333333 127.146667 0 85.3333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#30F2A2",
    points: "171.52 7.10542736e-15 256 41.8133333 171.52 85.3333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#14CC80",
    points: "171.52 0 85.3333333 41.8133333 85.3333333 127.146667 171.52 85.3333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#14CC80",
    points: "256 41.8133333 171.52 85.3333333 171.52 170.666667 256 127.146667"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildkiteIcon);
export default __webpack_public_path__ + "static/media/buildkite-icon.02fe7da1a5c3f8d3d0e4858622deb565.svg";
export { ForwardRef as ReactComponent };